import React, { useState, useEffect, useMemo } from 'react';
import { useTable, useSortBy, useGlobalFilter, usePagination } from "react-table";
import { Table, Container, Input } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { FaSistrix } from "react-icons/fa";
import CreateTableComponent from '../share/CreateTableComponent';
import { FaSort } from 'react-icons/fa';
import { Loading } from "../share/loading";
import { SearchFilter } from "../share/SearchFilter";
// import { FormatDate } from "../share/FormatDate";
// import { format } from 'date-fns'
import '../share/form.css';


export function ConsiderProfileComponent() {
    const user = JSON.parse(localStorage.getItem("userData"))
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [listDataUserChangeProfile, setListDataUserChangeProfile] = useState([]);
    console.log("listDataUserChangeProfile", listDataUserChangeProfile);

    useEffect(() => {
        getListDataUserChangeProfile()
    }, [])

    async function getListDataUserChangeProfile() {
        setLoading(true);
        let postData = new FormData();
        postData.append("deptId", user.deptId);

        try {
            const res = await fetch("/api/Profile/listReqChangeProfile", {
                method: "POST",
                headers: { 'token': user.token },
            })
            let resJson = await res.json()
            setListDataUserChangeProfile(resJson.dataenum);
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }

    const COLUMNS = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1,
            enableRowSpan: true
        },
        {
            Header: "วันที่",
            accessor: "createDate",
        },
        {
            Header: "ชื่อ",
            accessor: "fullName",

        },
        {
            Header: "รายละเอียด",
            accessor: "flagStatus",
            Cell: ({ row, value }) => {
                if (value === "รอการตรวจสอบ") {
                    // console.log(row)
                    return (
                        <>
                            {value}
                            <FaSistrix className="mx-3 style-icon"
                                onClick={() => navigate(`/request/profile-detail?req=${row.original.profileLogId}`)}
                            />
                        </>
                    )
                } else {
                    return (
                        <>
                            {value}
                            <FaSistrix className="mx-3 style-icon"
                                onClick={() => navigate(`/request/profile-detail?req=${row.original.profileLogId}`)}
                            />
                        </>
                    )
                }
            }
        },
    ]

    return (
        <Container className="mt-4">
            <CreateTableComponent
                column={COLUMNS}
                dataInput={listDataUserChangeProfile}
                // FormInput={<></>}
                showEntrie={true}
                showPage={true}
            />
        </Container>
    );
}



